import React, { FC } from 'react';
import './Error.scss';

interface ErrorProps {
    error: {
        statusText?: string;
        message?: string;
    };
}

const Error: FC<ErrorProps> = (props) => (
    <div data-testid="error">
        <h1>Oops!</h1>
        <p>Sorry, an unexpected error has occurred.</p>
        <p>
            <i>{props.error.statusText || props.error.message}</i>
        </p>
    </div>
);

export default Error;
